<template>
    <div>
<!--        <page-header :header-title=" $t('competition_search') " :header_side="true" :header_back="true"></page-header>-->
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <button slot="headerBtns" class="h_search_btn" @click="$router.push('/search')"></button>
        </page-header>
        <page-header class="sub_header" :header-title=" $t('competition_search') " ></page-header>
        <competition-list-component :competition-type="'searchCompetition'"></competition-list-component>
    </div>
</template>

<script>
import CompetitionListComponent from "@/components/competition/CompetitionListComponent";

export default {
    name: "SearchResultCompetition",
    mixins: [],
    components: {
        CompetitionListComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
